/*
 * Created Date: Thursday October 27th 2022
 * Author: Oskar Karnblad
 * License: Proprietary to Scaffcalc AB
 *
 * Copyright (c) 2022 Scaffcalc AB
 */
import { FC } from "react";
import LinearProgress from "@mui/material/LinearProgress";

export interface LinearProgressCustomInterface {
  value: number;
  valueBuffer: number;
  variant?: "buffer" | "determinate" | "indeterminate" | "query";
  color?: "inherit" | "primary" | "secondary" | string;
  style?: object;
}

const LinearProgressCustom: FC<LinearProgressCustomInterface> = (props) => {
  const { value, valueBuffer, variant, style } = props;

  return (
    <LinearProgress
      variant={variant}
      value={value}
      valueBuffer={valueBuffer}
      sx={style}
    />
  );
};

LinearProgressCustom.defaultProps = {
  variant: "indeterminate",
};

export default LinearProgressCustom;
